module.exports = __webpack_public_path__ + "img/Hui_SW_24.480ee0dd.jpg";